import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import Vue3Datatable from '@bhplugin/vue3-datatable';
import Multiselect from 'vue-multiselect';
import Vue3Dropzone from "@jaxtheprime/vue3-dropzone";
import VueDatePicker from '@vuepic/vue-datepicker';
import { Bootstrap5Pagination } from 'laravel-vue-pagination';

import '@vuepic/vue-datepicker/dist/main.css'
import '@bhplugin/vue3-datatable/dist/style.css';
import "vue-multiselect/dist/vue-multiselect.css";
import "@jaxtheprime/vue3-dropzone/dist/style.css";

const app = createApp(App)
app.component("DataTable",Vue3Datatable)
app.component("MSelect",Multiselect)
app.component("DropFiles",Vue3Dropzone)
app.component("IRange",VueDatePicker)
app.component("BPagination",Bootstrap5Pagination)
app.use(router)
app.use(store)
app.mount('#app')
